"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = require("../logger");
var Network = (function () {
    function Network() {
        this.XMLHttpRequest = this.generateXmlHttpRequestClass();
    }
    Network.prototype.fetch = function (url, options) {
        if (typeof url === 'object') {
            return Promise.reject('Request object not supported. Please use `fetch(url, options)` syntax.');
        }
        var _a = options || {}, _b = _a.headers, headers = _b === void 0 ? {} : _b, _c = _a.method, method = _c === void 0 ? 'GET' : _c, _d = _a.body, body = _d === void 0 ? null : _d, ignoredOptions = __rest(_a, ["headers", "method", "body"]);
        for (var ignoredOptionKey in ignoredOptions) {
            logger_1.defaultLogger.warn("Request made to " + url + " with unsupported option: " + ignoredOptionKey);
        }
        return this.makeRequest({
            url: url,
            headers: headers,
            method: method,
            body: body && body.toString(),
        })
            .catch(function (e) { return e; })
            .then(function (response) {
            return new Response(response && response.body, {
                status: response && response.status,
                headers: response && response.headers,
            });
        });
    };
    Network.prototype.generateXmlHttpRequestClass = function () {
        var networkInstance = this;
        return (function () {
            function FrameworkXMLHttpRequest() {
                this.UNSENT = 0;
                this.OPENED = 1;
                this.HEADERS_RECEIVED = 2;
                this.LOADING = 3;
                this.DONE = 4;
                this.timeout = 0;
                this.readyState = this.UNSENT;
                this.status = 0;
                this.statusText = '';
                this.upload = null;
                this.withCredentials = false;
                this.requestHeaders = {};
                this.responseXML = null;
                this.responseType = 'text';
                this.eventTarget = new DocumentFragment();
                this.addEventListener = this.eventTarget.addEventListener.bind(this.eventTarget);
                this.removeEventListener = this.eventTarget.removeEventListener.bind(this.eventTarget);
                this.dispatchEvent = this.eventTarget.dispatchEvent.bind(this.eventTarget);
            }
            FrameworkXMLHttpRequest.prototype.open = function (method, url) {
                this.requestMethod = method;
                this.responseURL = url;
                this.notifyReadyStateChange(this.OPENED);
            };
            FrameworkXMLHttpRequest.prototype.send = function (body) {
                var _this = this;
                if (body === void 0) { body = null; }
                this.notifyReadyStateChange(this.LOADING);
                networkInstance
                    .makeRequest({
                    url: this.responseURL,
                    method: this.requestMethod,
                    headers: this.requestHeaders,
                    body: body,
                })
                    .then(function (response) {
                    _this.notifyReadyStateChange(_this.DONE);
                    _this.status = response.status;
                    _this.responseHeaders = response.headers;
                    _this.responseText = response.body;
                    _this.response = response.body;
                    _this.dispatchEvent(new ProgressEvent('load'));
                    if (_this.onload) {
                        _this.onload();
                    }
                })
                    .catch(function (e) {
                    _this.notifyReadyStateChange(_this.DONE);
                    _this.dispatchEvent(new Event('error'));
                    if (_this.onerror) {
                        _this.onerror(e);
                    }
                });
            };
            FrameworkXMLHttpRequest.prototype.setRequestHeader = function (key, value) {
                this.requestHeaders[key] = value;
            };
            FrameworkXMLHttpRequest.prototype.getResponseHeader = function (key) {
                return this.responseHeaders[key];
            };
            FrameworkXMLHttpRequest.prototype.getAllResponseHeaders = function () {
                var _this = this;
                return Object.keys(this.responseHeaders)
                    .map(function (key) { return key + ": " + _this.responseHeaders[key]; })
                    .join('\r\n');
            };
            FrameworkXMLHttpRequest.prototype.overrideMimeType = function (mimeType) {
                this.mimeType = mimeType;
            };
            FrameworkXMLHttpRequest.prototype.abort = function () {
            };
            FrameworkXMLHttpRequest.prototype.notifyReadyStateChange = function (readyState) {
                this.readyState = readyState;
                this.dispatchEvent(new Event('readystatechange'));
                if (this.onreadystatechange) {
                    this.onreadystatechange();
                }
            };
            return FrameworkXMLHttpRequest;
        }());
    };
    return Network;
}());
exports.Network = Network;
var VanillaNetwork = (function (_super) {
    __extends(VanillaNetwork, _super);
    function VanillaNetwork() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VanillaNetwork.prototype.makeRequest = function (request) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url);
            for (var key in request.headers) {
                xhr.setRequestHeader(key, request.headers[key]);
            }
            xhr.onload = function () {
                var headerStrings = xhr
                    .getAllResponseHeaders()
                    .trim()
                    .split(/[\r\n]+/);
                var headers = headerStrings.reduce(function (obj, headerString) {
                    var _a = headerString.split(': '), key = _a[0], valueParts = _a.slice(1);
                    obj[key] = valueParts.join(': ');
                    return obj;
                }, {});
                resolve(__assign({ status: xhr.status }, (xhr.status !== 204 ? { body: xhr.response } : {}), { headers: headers }));
            };
            xhr.onerror = function (e) {
                reject(e);
            };
            xhr.send(request.body);
        });
    };
    VanillaNetwork.prototype.generateXmlHttpRequestClass = function () {
        return XMLHttpRequest;
    };
    return VanillaNetwork;
}(Network));
exports.VanillaNetwork = VanillaNetwork;
